import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import rootReducer from '../reducers/rootReducer';
import rootSaga from '../sagas/rootSaga';

// eslint-disable-next-line import/no-mutable-exports
let store;
const sagaMiddleware = createSagaMiddleware({
  onError: (e) => {
    // 上报saga 错误
    if (window.Raven) {
      window.Raven.captureException(e);
    }
  },
});

// set store
if (process.env.NODE_ENV !== 'production') {
  store = createStore(
    rootReducer,
    compose(
      applyMiddleware(sagaMiddleware),
      // eslint-disable-next-line no-underscore-dangle
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__({
        serialize: {
          options: true,
        },
      }) : f => f,
    ),
  );
} else {
  store = createStore(rootReducer, applyMiddleware(sagaMiddleware));
}

// run saga
sagaMiddleware.run(rootSaga);

// Enable Webpack hot module replacement for reducers
if (module.hot) {
  module.hot.accept('../reducers/rootReducer', () => {
    const nextRootReducer = rootReducer;
    store.replaceReducer(nextRootReducer);
  });
}

export default store;



// WEBPACK FOOTER //
// ./src/store/ReduxRootStore.js